'use client'

import {
  useCreateProject,
  useUpdateProject,
} from '@/services/mutations/project'

import { useGuardedMutation } from './guardedMutation'

const PROJECT_MUTATION_PERMISSION_MESSAGE =
  "Vous n'avez pas l'autorisation de modifier ce projet."

export const useAuthorizedCreateProject = (params: {
  canCreateProject: boolean
}) => {
  const mutation = useCreateProject()

  return useGuardedMutation(
    mutation,
    params.canCreateProject,
    PROJECT_MUTATION_PERMISSION_MESSAGE,
  )
}

export const useAuthorizedUpdateProject = (params: {
  canUpdateProject: boolean
}) => {
  const mutation = useUpdateProject()

  return useGuardedMutation(
    mutation,
    params.canUpdateProject,
    PROJECT_MUTATION_PERMISSION_MESSAGE,
  )
}
